export default "__VITE_ASSET__C6Si_lrg__"